
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.46468 2.88452L3.96468 3.84105C3.38989 3.94101 2.97029 4.43989 2.97029 5.0233V18.9767C2.97029 19.5601 3.38989 20.059 3.96468 20.159L9.46468 21.1155C10.1986 21.2431 10.8703 20.6782 10.8703 19.9332V4.06678C10.8703 3.32183 10.1986 2.75688 9.46468 2.88452ZM3.65626 2.06767C2.2193 2.31757 1.17029 3.56477 1.17029 5.0233V18.9767C1.17029 20.4353 2.2193 21.6824 3.65627 21.9324L9.15626 22.8889C10.9911 23.208 12.6703 21.7956 12.6703 19.9332V4.06678C12.6703 2.2044 10.9911 0.792042 9.15626 1.11114L3.65626 2.06767Z","fill":"#16171F"}}),_c('path',{attrs:{"d":"M1.17029 5.02329C1.17029 3.56476 2.2193 2.31756 3.65626 2.06766L9.15626 1.11114C10.9911 0.792033 12.6703 2.20439 12.6703 4.06677V19.9332C12.6703 21.7956 10.9911 23.208 9.15626 22.8889L3.65627 21.9323C2.2193 21.6824 1.17029 20.4352 1.17029 18.9767V5.02329Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.9926 16.6645C15.6411 17.0159 15.6411 17.5858 15.9926 17.9373C16.3441 18.2887 16.9139 18.2887 17.2654 17.9373L22.5662 12.6365C22.9177 12.285 22.9177 11.7152 22.5662 11.3637L17.2654 6.06292C16.9139 5.71145 16.3441 5.71145 15.9926 6.06292C15.6411 6.41439 15.6411 6.98424 15.9926 7.33571L19.7569 11.1L8.45408 11.1C7.95702 11.1 7.55408 11.503 7.55408 12C7.55408 12.4971 7.95702 12.9 8.45408 12.9H19.7571L15.9926 16.6645Z","fill":"#16171F"}})])
          )
        }
      }
    